/* global __DEV__ __TEST__ */

const silencedLogs = {
    dev: [],
    test: ["cancelling requests", "Possibly unhandled Error."],
    prod: [],
};

const logItem = (level, ...toLog) => {
    const filters = [].concat(
        __DEV__ ? silencedLogs.dev : [],
        __TEST__ ? silencedLogs.test : [],
        silencedLogs.prod
    );
    const [logKey] = toLog;
    const isFiltered =
        typeof logKey !== "string"
            ? false
            : filters.filter((f) => f.indexOf(logKey) > -1) < filters.length;
    if (!isFiltered) {
        console[level](...toLog); // eslint-disable-line no-console
    }
};

export default {
    /* eslint-disable no-console */
    none() {
        logItem("none", ...arguments);
    },
    error() {
        logItem("error", ...arguments);
    },
    warn() {
        logItem("warn", ...arguments);
    },
    info() {
        logItem("info", ...arguments);
    },
    debug() {
        logItem("debug", ...arguments);
    },
    trace() {
        logItem("trace", ...arguments);
    },
    /* eslint-enable no-console */
};
